import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

const DriverForm = ({
  form,
  validationErrors,
  salaryLabel,
  submitting,
  isEditMode,
  onSubmit,
  onFieldChange,
  onNestedFieldChange,
  onReset,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <h5 className="mb-3">Basic Information</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={form.name}
              onChange={(e) => onFieldChange("name", e.target.value)}
              placeholder="Enter full name"
              isInvalid={!!validationErrors.name}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>CNIC</Form.Label>
            <Form.Control
              type="text"
              value={form.cnic}
              onChange={(e) => onFieldChange("cnic", e.target.value)}
              placeholder="37405-1234567-1"
              isInvalid={!!validationErrors.cnic}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.cnic}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Contact Number</Form.Label>
            <Form.Control
              type="text"
              value={form.contactNumber}
              onChange={(e) => onFieldChange("contactNumber", e.target.value)}
              placeholder="03001234567"
              isInvalid={!!validationErrors.contactNumber}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.contactNumber}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select value={form.status} onChange={(e) => onFieldChange("status", e.target.value)}>
              <option value="available">Available</option>
              <option value="booked">Booked</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mb-3 mt-2">License Information</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>License Number</Form.Label>
            <Form.Control
              type="text"
              value={form.license.number}
              onChange={(e) => onNestedFieldChange("license", "number", e.target.value)}
              placeholder="RWP-DRV-1122"
              isInvalid={!!validationErrors["license.number"]}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors["license.number"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>License Expiry Date</Form.Label>
            <Form.Control
              type="date"
              value={form.license.expiryDate}
              onChange={(e) => onNestedFieldChange("license", "expiryDate", e.target.value)}
              isInvalid={!!validationErrors["license.expiryDate"]}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors["license.expiryDate"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mb-3 mt-2">Employment Information</h5>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Driver Type</Form.Label>
            <Form.Select
              value={form.employment.driverType}
              onChange={(e) => onNestedFieldChange("employment", "driverType", e.target.value)}
            >
              <option value="ad_hoc">Ad Hoc</option>
              <option value="permanent">Permanent</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Salary Type</Form.Label>
            <Form.Select
              value={form.employment.salaryType}
              onChange={(e) => onNestedFieldChange("employment", "salaryType", e.target.value)}
            >
              <option value="per_trip">Per Trip</option>
              <option value="monthly">Monthly</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>{salaryLabel}</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={form.employment.salaryAmount}
              onChange={(e) => onNestedFieldChange("employment", "salaryAmount", e.target.value)}
              placeholder="Enter amount"
              isInvalid={!!validationErrors["employment.salaryAmount"]}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors["employment.salaryAmount"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex gap-2 mt-3">
        <Button type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              {isEditMode ? "Saving..." : "Creating..."}
            </>
          ) : (
            isEditMode ? "Save Changes" : "Create Driver"
          )}
        </Button>
        <Button type="button" variant="light" disabled={submitting} onClick={onReset}>
          Reset
        </Button>
      </div>
    </Form>
  );
};

export default DriverForm;
